import { render, staticRenderFns } from "./customerRetention.vue?vue&type=template&id=613da860&"
import script from "./customerRetention.vue?vue&type=script&lang=js&"
export * from "./customerRetention.vue?vue&type=script&lang=js&"
import style0 from "./customerRetention.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports